import { IonButton, IonGrid, IonIcon, IonRippleEffect } from '@ionic/react';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { getCurrentUser } from '../../../utils/getClientInfo';
import WishlistIcon from '../../../pages/user/wish-list/wish-list-icon';
import { ProductType } from '../../../types/product';
import ImageCarousel from '../../ImageCarousel';
import { getProductStatus } from '../../../utils/products';
import classNames from 'classnames';
import { cartSharp } from 'ionicons/icons';
import AddToCartModal from '../../../pages/user/cart/inc/addToCartModal';
import { MdOutlineAddShoppingCart } from 'react-icons/md';
import useGlobalContext from '../../../hooks/useStore';

type ProductBlockProps = {
  data: ProductType;
  customStyles?: { wrapper?: string };
  isVendorView?: boolean;
};
const ProductBlock = ({
  data,
  customStyles = {},
  isVendorView,
}: ProductBlockProps) => {
  const { images, id, name, price, store } = data;
  const globalState = useGlobalContext();
  const history = useHistory();
  const client = getCurrentUser();
  const [path, setPath] = useState<string>('');
  const [isInCart, setIsInCart] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    let state = globalState.cartState.cart!.find((e) => e.product.id === id);
    if (state) {
      setIsInCart(true);
    }
  }, [globalState.cartState.cart]);

  useEffect(() => {
    if (client.role === 'seller' && location.pathname.includes('dashboard')) {
      setPath(`/dashboard/items/detail?q=${id}&i=${name.slice(0, 30)}`);
    } else {
      setPath(`/${store?.name}/product/${name.slice(0, 30)}?id=${id}`);
    }
  }, []);

  const status = useMemo(() => {
    return getProductStatus(data.status || '');
  }, [data?.status]);

  const statusBadge = classNames(
    'px-3 py-[2px]  text-xs  rounded-md capitalize font-semibold',
    {
      'bg-orange-200 text-orange-500': status === 'pending',
      'bg-gray-200 text-gray-500': status === 'draft',
      'bg-red-200 text-red-500': status === 'rejected',
      'bg-green-200 text-green-500': status === 'published',
    }
  );

  return (
    <>
      <AddToCartModal trigger={`product-${id}-trigger`} product={data} />
      <div
        className={`relative flex flex-col w-full  h-[250px] md:h-[320px]  shadow-xs bg-white ${customStyles.wrapper}`}
        onClick={() => {
          history.push({
            pathname: path,
            state: { id },
          });
        }}
      >
        <div className="relative w-full h-[75%] md:h-[80%]">
          <ImageCarousel
            data={images}
            name={data.name}
            outOfStock={data.outOfStock}
          />

          {!isVendorView && (
            <div className="absolute  items-center bottom-2 right-2 z-50 cursor-pointer ">
              <WishlistIcon productId={data.id} />
            </div>
          )}

          {isVendorView && data.outOfStock && (
            <div className="absolute flex justify-center  items-center inset-0 z-50 bg-black/20 text-white font-bold text-base md:text-lg">
              Out of Stock
            </div>
          )}
          {data?.views?.length! > 4 && (
            <div className="absolute italic rounded-sm text-xs text-white p-1 capitalize font-bold items-center top-0 left-0 z-50 cursor-pointer bg-secondary ">
              Trending
            </div>
          )}
        </div>
        <IonGrid className="m-0 px-2 py-2 text-black">
          <div className="w-full h-auto flex items-center justify-between">
            <p className="text-base w-[90%] font-light capitalize whitespace-nowrap overflow-hidden text-ellipsis ">
              {data.name}
            </p>
            {!isVendorView && (
              <div
                className={
                  'relative overflow-hidden size-auto flex justify-end items-center border-primary border-[1px] rounded-full p-[2%] md:p-[1%]  cursor-pointer ion-activatable ripple-parent circle ' +
                  classNames({ '!border-secondary': isInCart })
                }
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  console.log(e.currentTarget)
                }}
                id={`product-${id}-trigger`}
              >
                <IonRippleEffect></IonRippleEffect>
                <MdOutlineAddShoppingCart
                  className={
                    'size-4 text-primary ' +
                    classNames({ '!text-secondary': isInCart })
                  }
                />
              </div>
            )}
          </div>

          <div className="w-full text-md font-medium h-auto ">
            UGX{' '}
            {price.toLocaleString('en-US', {
              maximumFractionDigits: 2,
            })}
          </div>
          {isVendorView && (
            <div className="flex w-full mt-1 ">
              <span className={statusBadge}>{status}</span>
            </div>
          )}
        </IonGrid>
      </div>
    </>
  );
};

export default ProductBlock;
